import { useState, useEffect, useCallback } from "react";
import { Activity } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { api } from "./adminApi";

export default function AuditTab() {
  const [logs, setLogs] = useState([]);
  const [entityType, setEntityType] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const params = entityType ? `?entity_type=${entityType}` : "";
      const r = await api.get(`/admin/audit-logs${params}`);
      setLogs(r.data);
    } catch { toast.error("Impossible de charger l'audit"); }
    finally { setLoading(false); }
  }, [entityType]);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);

  const types = ["", "offer", "candidate", "agency", "reminder", "candidate_note", "user", "campaign"];
  const labels = { "": "Tous", offer: "Offres", candidate: "Candidats", agency: "Agences", reminder: "Rappels", candidate_note: "Notes", user: "Utilisateurs", campaign: "Campagnes" };

  return (
    <div data-testid="audit-tab" className="space-y-4">
      <div className="flex flex-wrap gap-2">
        {types.map((t) => (
          <button key={t || "all"} onClick={() => setEntityType(t)}
            className={`px-3 py-1.5 text-xs font-semibold border ${entityType === t ? "bg-[#662483] text-white border-[#662483]" : "bg-white text-gray-700 border-gray-200 hover:border-gray-400"}`}
            data-testid={`audit-filter-${t || "all"}`}>{labels[t]}</button>
        ))}
      </div>
      {loading ? <p className="text-center py-12 text-gray-500">Chargement…</p>
        : logs.length === 0 ? (
          <div className="bg-white border border-gray-200 p-8 text-center">
            <Activity className="w-8 h-8 mx-auto mb-2 text-gray-300" />
            <p className="text-sm text-gray-500">Aucune action enregistrée pour ce filtre.</p>
          </div>
        ) : (
        <div className="bg-white border border-gray-200 divide-y divide-gray-100 max-h-[70vh] overflow-y-auto">
          {logs.map((l) => (
            <div key={l.log_id} className="px-4 py-2 text-xs flex items-center gap-3 hover:bg-gray-50" data-testid={`audit-log-${l.log_id}`}>
              <Badge className="bg-[#F0E9F3] text-[#662483] rounded-none uppercase font-bold w-20 justify-center shrink-0">{l.action}</Badge>
              <span className="text-gray-500 shrink-0 w-24 truncate">{l.entity_type}</span>
              <span className="flex-1 truncate text-[#3F3F3F]">
                {l.admin_email && <span className="text-[#0069B4]">{l.admin_email}</span>}
                {l.entity_id && <span className="text-gray-400 ml-2">→ {l.entity_id}</span>}
                {l.payload && Object.keys(l.payload).length > 0 && (
                  <span className="text-gray-500 ml-2">{Object.entries(l.payload).slice(0, 3).map(([k, v]) => `${k}=${typeof v === "object" ? JSON.stringify(v).slice(0, 30) : String(v).slice(0, 40)}`).join(", ")}</span>
                )}
              </span>
              <span className="text-gray-400 shrink-0">{l.created_at?.slice(0, 16).replace("T", " ")}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
